import { contactAnonymousUser, contactUser, getAnonymousContactData } from "api/contact";
/* Wrapper for all contact ajax activity */
class ContactRepository {
    /**
     * Send contact data to API
     *
     * @method submitPublicContact
     * @param {Object} contact Information to send with request
     * @returns {axios.Promise}
     */
    submitPublicContact(contact) {
        return contactAnonymousUser(contact).then(({ data }) => data);
    }
    /**
     * Send (secured) contact data to API
     *
     * @method submitSecureContact
     * @param {Object} contact Information to send with request
     * @returns {axios.Promise}
     */
    submitSecureContact(contact) {
        return contactUser(contact).then(({ data }) => data);
    }
    getContactData() {
        return getAnonymousContactData().then(({ data }) => data);
    }
}
export default new ContactRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/contact/ContactRepository.ts